module.exports = __webpack_public_path__ + "static/media/marker_empty.da254157.svg";


//////////////////
// WEBPACK FOOTER
// ./src/markers/marker_empty.svg
// module id = 243
// module chunks = 0